import React, { useState } from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import styles from './_WorkflowTarefaDescricao.less';
import PropTypes from "prop-types";
import ActionBar from "../../../components/action-bar";
import ActionLink from "../../../components/action-link";

export default function WorkflowTarefaDescricao(props) {
  const { descricao, onSubmit, readOnly } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [edicao, setEdicao] = useState(false);

  const fireSubmit = descricao => {
    let promise = Promise.resolve();
    if (typeof onSubmit === 'function')
      promise = promise.then(() => onSubmit(descricao));
    return promise;
  }

  const handleClick = e => {
    if (readOnly)
      return;
    e.preventDefault();
    form.resetFields();
    setEdicao(true);
  }

  const handleFinish = values => {
    fireSubmit(values.descricao).then(() => setEdicao(false));
  }

  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="descricao" initialValue={descricao} noStyle>
          <Input.TextArea autoFocus autoSize placeholder={t('Descrição')}/>
        </Form.Item>
        <ActionBar>
          <ActionLink.Save onClick={form.submit}/>
          <ActionLink.Cancel onClick={() => setEdicao(false)}/>
        </ActionBar>
      </Form>
    );
  }

  let className = styles['workflow-tarefa-descricao'];
  if (!descricao)
    className += ' ' + styles['nao-preenchido'];
  if (readOnly)
    className += ' ' + styles['read-only'];

  return (
    <div className={className} onClick={handleClick}>
      {descricao ?? t('(não preenchido)')}
    </div>
  );
}

WorkflowTarefaDescricao.propTypes = {
  descricao: PropTypes.string,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool
}